document.addEventListener('DOMContentLoaded', () => {
  const targetImg = document.querySelector(
    '.yc-slider-gallery-contents__target img'
  );

  if (!targetImg) return;

  const updateImage = () => {
    const nextSlideImg = document.querySelector(
      '.yc-slider-gallery-controller__item.swiper-slide-next img'
    );

    if (!nextSlideImg) return;

    targetImg.src = nextSlideImg.src;
    targetImg.srcset = nextSlideImg.srcset;
    targetImg.sizes = nextSlideImg.sizes || '';
    targetImg.alt = nextSlideImg.alt || '';
  };

  // 初期表示
  updateImage();

  // swiper-wrapperのクラス変化を監視
  const wrapper = document.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  const observer = new MutationObserver(updateImage);

  observer.observe(wrapper, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
});

